import isNullOrUndefined from './isNullOrUndefined'

// return true if element equals value
const workflowIndicatorFilter = (el, val, filterCol) => {
    if (isNullOrUndefined(el[filterCol])) {
        return false; 
    }
    // get array of indicators 
    let indicators = el[filterCol].split("; "); 
    // check if id is included in indicators 
    return indicators.includes(val);
}

export default workflowIndicatorFilter;